import { Link } from 'react-router-dom';

import Tag from '../../../common/components/tag/tag';
import TeamIcon from '../../../common/icons/team';
import { TASK_KIND_LABEL, WORKFLOW_STATE_LABEL } from '../../../core/constants/domain';
import { ROUTES } from '../../../core/constants/routes';
import { isFinding } from '../utils/board';

import '../styles/board-card.css';

export default function BoardCard({ task, tierName, repository }) {
    // A card waiting for review opens the review, not the task: what someone
    // does with a waiting delivery is look at it and decide it.
    const isInReview = task.state === 'in_review';
    const isProposal = task.state === 'proposed';

    return (
        <li className={`board-card${isProposal ? ' board-card--proposal' : ''}`}>
            <span className="board-card__id">#{task.id}</span>
            <Link
                to={isInReview ? ROUTES.REVIEW(task.id) : ROUTES.TASK(task.id)}
                className="board-card__title"
                title={isInReview ? 'Abrir su revisión' : undefined}
            >
                {task.title}
            </Link>
            {isFinding(task) && (
                <Link to={ROUTES.TASK(task.originTaskId)} className="board-card__finding">
                    Hallazgo · de #{task.originTaskId}
                </Link>
            )}
            <span className="board-card__meta">
                <span className={`board-card__kind board-card__kind--${task.kind}`}>{TASK_KIND_LABEL[task.kind] ?? task.kind}</span>
                <span className={`board-card__state board-card__state--${task.state}`}>{WORKFLOW_STATE_LABEL[task.state] ?? task.state}</span>
                {task.modality === 'one_off'
                    ? <span className="board-card__oneoff" title="Tarea puntual: sin tier ni plan">Puntual</span>
                    : tierName && <span className="board-card__tier" title={tierName}>{tierName.split(' · ')[0]}</span>}
            </span>
            <span className="board-card__meta board-card__meta--where">
                {repository && <Tag swatch={repository.kind}>{repository.name}</Tag>}
                {task.assignee && (
                    <span className="board-card__assignee" title={`Responsable: ${task.assignee}`}>
                        <TeamIcon size={14} />
                        {task.assignee}
                    </span>
                )}
            </span>
        </li>
    );
}
